// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const StopIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="StopIcon" ref={forwardedRef} {...props}>
      <path d="M15 5.036v10H5v-10zm-11.5-1.5v13h13v-13z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const StopIcon = /* @__PURE__ */ Object.assign(StopIconComponent, {
  displayName: 'StopIcon',
});
